import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMsal, useIsAuthenticated } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';
import { Loading } from '../../ui/components';

// Handles the redirect back from Microsoft Entra ID.
// MsalProvider already calls handleRedirectPromise() — we just wait for MSAL
// to finish processing, then forward to /admin.
export const AuthCallback = () => {
  const { inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const navigate = useNavigate();

  useEffect(() => {
    if (inProgress !== InteractionStatus.None) {
      return;
    }

    navigate('/admin', { replace: true });
  }, [inProgress, isAuthenticated, navigate]);

  return <Loading />;
};
